import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import {useState} from 'react';

export function VideoAd({handleVideoAdComplete}) {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
    handleVideoAdComplete(true)
  };
  const handleOpen = () => {
    setOpen(true);
    setTimeout(() => handleClose(), 3000)
  };


  return <div>
    <Button onClick={handleOpen} variant={'outlined'}>Watch video Ad</Button>
    <Backdrop
      sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
      open={open}
      onClick={handleClose}
    >
      <CircularProgress color="inherit"/>
      Video Ad playing...
    </Backdrop></div>
}